<template>
  <div class="body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <div class="mt-2">
          <el-row :gutter="10">
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-input
                  @change="selectSearchCode"
                  placeholder="بحث بالفاتورة "
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <div class="bg-White p-3">
                <SearchSuppliers
                  :searchOnly="true"
                  :supplier="supplier"
                  @selectedSupplier="selectedSupplier"
                  :productsLength="productsLength"
                  :productSearch="false"
                />
              </div>
            </el-col>
            <el-col :xl="9" :lg="9" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-date-picker
                  @change="selectDateRange"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  style="width: 100%"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              :xl="2"
              :lg="2"
              :md="6"
              :sm="12"
              v-if="accessLinks('print_purchase_bill')"
            >
              <div class="bg-White p-3">
                <el-button
                  type="success"
                  title="طباعه"
                  icon="el-icon-printer"
                  @click="sendToPrintAll(tableData)"
                ></el-button>
              </div>
            </el-col>
          </el-row>
          <customer-info
            :customer="supplier"
            :type="'supplier'"
            v-if="supplier != null"
          />
        </div>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          :style="supplier ? 'max-height: 74%;' : 'max-height: 80%;'"
        >
          <!-- <el-table-column label="#" type="index" width="50"> </el-table-column> -->
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>
          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="مرتجع" prop="returned_amount">
          </el-table-column>
          <el-table-column label="الاجمالي">
            <template slot-scope="scope">
              {{
                numberToFixed(
                  scope.row.total_cost -
                    scope.row.returned_amount -
                    scope.row.discount
                )
              }}
            </template>
          </el-table-column>
          <el-table-column width="170" label="المورد" prop="supplier.name">
          </el-table-column>
          <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
            <template slot-scope="scope">
              {{ scope.row.created_at | moment("Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
          <el-table-column label="اجراءات" width="120">
            <template slot-scope="scope">
              <el-row>
                <!-- <el-col :lg="12" v-if="accessLinks('update_purchase_bill')">
                  <router-link
                    title="تعديل الفاتورة"
                    :to="{ path: '/purchases/edit/' + scope.row.id }"
                  >
                    <el-button
                      size="mini"
                      type="warning"
                      title="تعديل"
                      icon="el-icon-edit"
                    ></el-button>
                  </router-link>
                </el-col> -->
                <el-col :lg="12" v-if="accessLinks('print_purchase_bill')">
                  <el-button
                    type="success"
                    size="mini"
                    title="طباعه"
                    icon="el-icon-printer"
                    @click="sendToPrint(scope.row)"
                  ></el-button>
                </el-col>
                <!-- <el-col :lg="8">
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    title="هل تريد حذف البيانات؟"
                    @confirm="deleteInvoice(scope)"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      size="mini"
                      title="مسح"
                      icon="el-icon-delete"
                    ></el-button>
                  </el-popconfirm>
                </el-col> -->
              </el-row>
              <!-- <el-button-group> -->
              <!-- <router-link
                  title="تعديل الفاتورة"
                  :to="{ path: '/purchases/edit/' + scope.row.id }"
                >
                  <el-button type="warning" title="تعديل" icon="el-icon-edit">
                    تعديل
                  </el-button>
                </router-link> -->
              <!-- <el-popconfirm
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                title="هل تريد حذف البيانات؟"
                @confirm="deleteInvoice(scope)"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  title="مسح"
                  icon="el-icon-delete"
                ></el-button>
              </el-popconfirm> -->
              <!-- </el-button-group> -->
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                class="mt-2"
                align="right"
                :data="props.row.products"
                border
                style="width: 80%; margin: auto"
              >
                <!-- <el-table-column label="#" type="index" width="50">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="المنتج"
                  width="300"
                  prop="name"
                ></el-table-column>
                <el-table-column label="الكمية " prop="pivot.qty">
                </el-table-column>
                <el-table-column
                  label="السعر "
                  prop="pivot.buy_cost"
                ></el-table-column>
                <el-table-column label="الاجمالي">
                  <template slot-scope="scope">
                    {{ scope.row.pivot.qty * scope.row.pivot.buy_cost }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="مرتجع"
                  sortable
                  prop="pivot.returned_qty"
                ></el-table-column>
                <el-table-column label="الاجمالي بعد المرتجع" width="150">
                  <template slot-scope="scope">
                    {{
                      (scope.row.pivot.qty - scope.row.pivot.returned_qty) *
                      scope.row.pivot.buy_cost
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <el-button
              style="width: 100%"
              v-if="tableData.length > 0 && pagination.last_page > 1"
              @click="loadMoreData"
              icon="el-icon-caret-bottom"
              >تحميل المزيد</el-button
            >
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchSuppliers from "@/components/Suppliers/SearchWithoutAdd.vue";
import CustomerInfo from "../../components/CustomerInfo.vue";
// import { ipcRenderer } from "electron";

export default {
  name: "Products",

  components: { SearchSuppliers, CustomerInfo },

  data() {
    return {
      true: true,
      productsLength: 0,
      supplier: null,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      current_page: 1,
      page_limit: 1,
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      filterMode: false,
    };
  },
  created() {
    this.getPurchases();
  },
  methods: {
    sendToPrint(row) {
      console.log("🚀 ~ sendToPrint ~ row:", row)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "saleInvoice",
      //   title: "شراء",
      //   invoiceType: "sales",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    sendToPrintAll(row) {
      console.log("🚀 ~ sendToPrintAll ~ row:", row)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "allReports",
      //   title: " مشتريات ",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    selectedSupplier(e) {
      this.supplier = e.supplier;
      this.filterMode = true;
      this.getPurchases();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getPurchases();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getPurchases();
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getPurchases();
      }
    },
    deleteInvoice(invoice) {
      // alert(invoice.row.id);
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      axiosApi
        .delete(`purchases/${invoice.row.id}`)
        .then(() => {
          this.getPurchases();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حذف فاتورة المشتريات بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "حدث خطأ",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    getPurchases() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.filterMode) {
        this.tableData = [];
        this.pagination.current_page = 1;
        this.filterMode = false;
      }
      let url = `inventory-purchases/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}`;
      if (this.dateRange != null) {
        url += "&start_date=" + this.dateRange[0];
        url += "&end_date=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.supplier != null) {
        url += "&supplier=" + this.supplier.id;
      }

      axiosApi
        .get(url)
        .then((res) => {
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          this.tableData.map((invoice) => {
            invoice.total = this.numberToFixed(
              invoice.total_cost - invoice.discount
            );
            invoice.total_cost = this.numberToFixed(invoice.total_cost);
            invoice.discount = this.numberToFixed(invoice.discount);
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
